import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchHoofdnetValuelists,
  initialState,
} from '../services/fetchHoofdnetValuelists'

export { useHoofdnetValuelists }

const queryKey = 'valuelists-hoofdnet'

const useHoofdnetValuelists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchHoofdnetValuelists,
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
